export default __webpack_public_path__ + "static/media/Trim-Empire.630de901.png";